// extracted by mini-css-extract-plugin
module.exports = {"initials":"UserInfo_initials__2TVLS","logoutBtn":"UserInfo_logoutBtn__1QHeJ","name":"UserInfo_name__36HAB"};